<template>
  <div class="main container">
    <div
      v-if="showBackButton"
      class="back-btn"
      @click="back"
    >
      <i class="fas fa-angle-left"/>
      <span>
        {{ $t('button.back') }}
      </span>
    </div>
    <div class="col-md-12 text-center">
      <p class="text-header highlight-color">
        {{ textHeader }}
      </p>
    </div>
    <StepProgress
      :steps="steps"
      :active="active"
      :class="`custom-step-progress`"
    />
    <BasePaymentForm v-if="loading">
      <template #body>
        <BaseLoading />
      </template>
    </BasePaymentForm>
    <slot v-else/>
  </div>
</template>

<script>
import StepProgress from '@/components/custom/StepProgress.vue'

export default {

  components: {
    StepProgress,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    textHeader: {
      type: String,
      default: null,
    },
    steps: {
      type: Array,
      default: () => ([]),
    },
    active: {
      type: Number,
      default: 0,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    back () {
      const backToHomeRouteNamesList = [
        'PaymentCallbackAuth',
      ]
      if (backToHomeRouteNamesList.includes(this.$route.name)) {
        this.$router.push({ name: 'Home' })
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
.main {
  margin-top: 50px;
}

.text-header {
  font-size: 22px;
}

.custom-step-progress {
  max-width: 600px;
  margin: 30px auto;
}

.back-btn {
  position: absolute;
  top: 10px;
  left: 5px;
  display: flex;
  align-items: center;
  color: #fff;
  cursor: pointer;
  padding: 6px 20px;
}

.back-btn span {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BasePayment.vue